import minhImage from "../../public/minh1.png";

function ArticleHeaderMobile({
  date,
  thumbnail,
  title,
  description,
  linkedinPost,
  githubRepo,
  youtube,
  note,
}: any) {
  return (
    <div className="flex flex-col gap-20 mt-12">
      <div>
        <div className="flex flex-col gap-8">
          <div className="flex lg:max-w-[92%]  flex-col gap-4 text-pretty">
            <p className="text-[26px] font-semibold leading-tight tracking-wide">
              {title}
            </p>
            {note && (
              <p className="underline underline-offset-4 text-custom-green mb-2">
                {note}
              </p>
            )}
            {description && <p className="text-gray-6">{description}</p>}
          </div>

          <div>
            <div className="flex max-w-none items-center gap-4">
              <div className="h-10 w-10 relative inline-flex select-none items-center justify-center overflow-hidden rounded-full align-middle">
                <img
                  loading="lazy"
                  decoding="async"
                  sizes="80px"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    inset: "0px",
                    color: "transparent",
                  }}
                  alt="minh"
                  src={minhImage}
                />
              </div>
              <div className="leading-tight">
                <p className="font-normal text-[18px] mb-1">Minh Le</p>
                <div className="flex flex-row">
                  <p className="text-gray-6 ">
                    <time>{date}</time>
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-4 flex flex-row underline underline-offset-4  text-[15px]">
              {githubRepo && (
                <a className="mr-6" href={githubRepo} target="_blank">
                  Github Repo
                </a>
              )}
              {linkedinPost && (
                <a href={linkedinPost} target="_blank">
                  Linkedin Post
                </a>
              )}
              {youtube && (
                <a href={youtube} target="_blank">
                  Youtube Demo
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="h-8"></div>
        <img
          alt="thumbnail"
          fetchPriority="high"
          decoding="async"
          data-nimg="1"
          className="-ml-6 w-[calc(100%+48px)] max-w-none"
          style={{ color: "transparent" }}
          src={thumbnail}
        ></img>
      </div>
    </div>
  );
}

export default ArticleHeaderMobile;
